import TrapFocus from 'utils/trap-focus';
import './shipping-flyout-panel.css';

export default (element) => {
  const overlay = element.querySelector('[data-shipping-flyout-panel-overlay]');
  const close = element.querySelector('[data-shipping-flyout-panel-close]');
  const chatIcon = element.querySelector('[data-flyout-panel-chat-link]');
  const trapFocus = new TrapFocus(element.querySelector('.flyout-panel__panel'));
  let flyoutOpenElement = null;

  const openFlyout = (e) => {
    element.classList.add('flyout-panel--open');
    document.body.classList.add('no-scroll');
    trapFocus.init();
    flyoutOpenElement = e.detail.el;
  };

  const closeFlyout = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (
      e.target.classList.contains('flyout-panel__overlay')
      || e.target === close 
      || e.target.parentElement === close 
      || e.target.parentElement.parentElement === close
      || e.target === chatIcon 
      || e.target.closest('[data-flyout-panel-chat-link]')
    ) {
      element.classList.remove('flyout-panel--open');
      document.body.classList.remove('no-scroll');
      trapFocus.destroy(flyoutOpenElement);
    };
  };

  const handleChatIconClick = (e) => {
    closeFlyout(e);
    if (chatIcon.hasAttribute('data-service-chat-enabled')) {
      // Trigger the click on the service chat button
      document.querySelector('.helpButtonEnabled').click();
    }
  };

  const init = () => {
    overlay.addEventListener('click', closeFlyout); 
    close.addEventListener('click', closeFlyout);
    chatIcon?.addEventListener('click', handleChatIconClick);
    document.addEventListener('shippingFlyoutPanel:open', openFlyout);
  };

  init();
};
